import { render, staticRenderFns } from "./VainWin.vue?vue&type=template&id=5cd683de&scoped=true"
import script from "./VainWin.vue?vue&type=script&lang=js"
export * from "./VainWin.vue?vue&type=script&lang=js"
import style0 from "./VainWin.vue?vue&type=style&index=0&id=5cd683de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd683de",
  null
  
)

export default component.exports